import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { NavLink } from 'react-router-dom';
import { ConfigContext } from "../../Context/ConfigContext";
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { AddToCartNotifier } from "../CartComponents";
import axios from "axios";
import { CartsContext } from "../../Context/CartsContext";
import DeliveryDaysComponent from "../../Pages/SpareParts/PartDetails/DeliveryDaysComponent";
import { UseRewardsPoints } from "../GlobalFunctions";
import { default_image } from "../../Imgaes";
import Config from "../../appConfig";

const PartsHorizontalCard = ({
  partImg,
  id,
  number,
  title,
  mrp,
  price,
  qty,
  imgUrl,
  url,
  criteria,
  brand,
  display_price,
  pt_intl,
  suplogo,
  art_type,
  mfa_id,
  part,
  SUP_WARRANTY,
  stock_delivery_days,
  isBattery
}) => {

  const {
    gdcURL,
    isUserInternational,
    setIsCartDropdownOpen,
    business_delivery_days,
    FavItems,
    business_type,
    business_id,
    currency
  } = useContext(ConfigContext);

  const {
    AddToCart,
    GetCartItemQty,
    loadings,
    AddToFavorite,
    RemoveToFavorite,
    GetStockPolicyItem,
  }
    = useContext(CartsContext);

  const { t } = useTranslation();
  const dir = localStorage.getItem('dir');
  const [selectQty, setSelectedQty] = useState(1);
  const [PTINTL, setPTINTL] = useState(pt_intl);
  const [isFavorite, setIsFavorite] = useState(false);

  const [addToCartLoading, setAddToCartLoading] = useState(false);
  const isAddingRef = useRef(false);


  var partURL = url;

  useEffect(() => {
    if (!isUserInternational) {
      setPTINTL(1)
    }
  }, [])

  useEffect(() => {
    var isFavoriteV = FavItems && FavItems.find(item => item.item_number.replaceAll(/\s/g, '') === number.replaceAll(/\s/g, ''));
    setIsFavorite(!!isFavoriteV);
  }, [FavItems])


  const [policyMinQty, setPolicyMinQty] = useState(1);

  useEffect(() => {
    const getPolicy = async () => {
      const stockPolicy = await GetStockPolicyItem(
        part?.ART_SEARCH_NUMBER,
        part?.stock_oe,
        part?.stock_sup_id ?? part?.SUP_ID ?? part?.ART_SUP_ID,
        brand
      );

      setPolicyMinQty(Number(stockPolicy?.policy_min_qty || 1));
      setSelectedQty(Number(stockPolicy?.policy_min_qty || 1));
    };

    if (part?.ART_SEARCH_NUMBER) {
      getPolicy();
    }
  }, [part]);

  const handleAddToCart = async () => {
    if (isAddingRef.current) return;

    isAddingRef.current = true;
    setAddToCartLoading(true);

    try {
      const prev_qty = Number(await GetCartItemQty(part?.ART_SEARCH_NUMBER));

      const stock = Number(part?.VD_QTY);
      const addQty = Number(selectQty);

      if (stock >= prev_qty + addQty) {

        const item = {
          ART_ID: id,
          ART_ARTICLE_NR: part?.ART_SEARCH_NUMBER,
          PRODUCT_GROUP_EN: title,
          stock_price_mrp: mrp,
          VD_BB_PRICE: price,
          VD_BG_PRICE: price,
          ART_SUP_ID:
            part?.stock_sup_id ??
            part?.SUP_ID ??
            part?.ART_SUP_ID ??
            0,
          ART_SUP_BRAND: brand,
          inventory_store_id: part?.inventory_store_id,
          stock_oe: part?.stock_oe ?? 0,
          VD_QTY: stock,
          stock_delivery_days: part?.stock_delivery_days,
        };

        await AddToCart(item, addQty, imgUrl, url);

        setIsCartDropdownOpen(true);
        window.scrollTo(0, 0);

      } else {

        toast.success(
          <AddToCartNotifier
            item_name={t("sorry_we_have_only", {
              value: stock,
            })}
            item_img={imgUrl}
          />
        );

      }

    } finally {
      setAddToCartLoading(false);
      isAddingRef.current = false;
    }
  };

  const incrementQty = async () => {
    const prev_qty = Number(await GetCartItemQty(part?.ART_SEARCH_NUMBER));

    const stock = Number(part?.VD_QTY);
    const step = Number(policyMinQty || 1);
    const currentQty = Number(selectQty);

    const nextQty = currentQty + step;

    // Full step available
    if (stock >= prev_qty + nextQty) {
      setSelectedQty(nextQty);
      return;
    }

    // Last remaining stock
    const remainingStock = stock - prev_qty;

    if (remainingStock > currentQty) {
      setSelectedQty(remainingStock); // Example: 26
      return;
    }

    toast.success(
      <AddToCartNotifier
        item_name={t("sorry_we_have_only", {
          value: stock,
        })}
        item_img={imgUrl}
      />
    );
  };

  const decrementQty = () => {
    const step = Number(policyMinQty || 1);
    const currentQty = Number(selectQty);

    // Example: 26 -> 20
    if (currentQty % step !== 0) {
      setSelectedQty(Math.floor(currentQty / step) * step);
      return;
    }

    // 20 -> 10 -> 10
    setSelectedQty(Math.max(step, currentQty - step));
  };


  const handleRemoveToFavorite = async () => {
    try {
      await RemoveToFavorite(part)
    } catch (error) {
      // setLoading(false);
    }
  }

  const handleAddToFavorite = async () => {
    try {

      const data = {
        business_id,
        item_id: id,
        item_number: part?.ART_SEARCH_NUMBER,
        item_title: title,
        item_sup_id: part?.ART_SUP_ID || part?.stock_sup_id || 0,
        item_mrp: mrp,
        item_price: Number(business_type) === 1 ? part?.VD_BG_PRICE : part?.VD_BB_PRICE,
        item_qty: 1,
        item_img_url: partImg,
        item_url: url,
        max_qty: qty,
        item_store_id: part?.inventory_store_id,
        item_stock_oe: part?.stock_oe,
        item_delivery_days: stock_delivery_days,
        item_brand_name: part?.stock_brand_name
      };

      await AddToFavorite(data)
    } catch (error) {

    }
  };

  const GetWarrantyImage = (warranty) => {
    switch (warranty) {
      case '1 Year':
        return '1year.gif';
      case '6 Months':
        return '6month.gif';
      case '3 Years':
        return '3_years_warranty.png';
      default:
        return '1_year_warranty.png';
    }
  };

  const numericPriceDisplay = Number(
    display_price.replace(/[^\d.]/g, '')
  );

  const beforePrice =
    business_type === 1
      ? part?.stock_before_bg_price
      : part?.stock_before_bb_price;

  const parsedCriteria = useMemo(() => {
    try {
      if (!criteria) return [];

      // Already an array
      if (Array.isArray(criteria)) {
        return criteria;
      }

      // Stringified JSON
      if (typeof criteria === "string") {
        const parsed = JSON.parse(criteria);

        // Handle accidentally double-stringified JSON
        return typeof parsed === "string" ? JSON.parse(parsed) : parsed;
      }

      // Already an object
      return criteria;
    } catch (err) {
      console.error("Criteria Parse Error:", err);
      console.log("criteria =", criteria);
      return [];
    }
  }, [criteria]);

  // const batteryVoltage = isBattery ? parsedCriteria.find((item) => item.criteria_en?.toLowerCase() === "voltage [v]")?.value_en : null;
  // const batteryCapacity = isBattery
  //   ? parsedCriteria.find((item) =>
  //     ["capacity [ah]", "battery capacity [ah]"].includes(
  //       item.criteria_en?.trim().toLowerCase()
  //     )
  //   )?.value_en
  //   : null;

  // const productTitle = isBattery ? [title, batteryVoltage, batteryCapacity, number].filter(Boolean).join(" ") : `${title} - ${number} - ${brand}`;

  const batteryVoltage = isBattery
    ? parsedCriteria.find(
      (item) =>
        item.criteria_en?.trim().toLowerCase() === "voltage [v]"
    )?.value_en
    : null;

  const batteryCapacity = isBattery
    ? parsedCriteria.find((item) =>
      ["capacity [ah]", "battery capacity [ah]"].includes(
        item.criteria_en?.trim().toLowerCase()
      )
    )?.value_en
    : null;

  const productTitle = isBattery
    ? [
      title,
      batteryVoltage ? `V${batteryVoltage}` : null,
      // batteryCapacity ? `Battery Capacity ${batteryCapacity}Ah` : null,
      batteryCapacity ? `${batteryCapacity}Ah` : null,
      number,
    ]
      .filter(Boolean)
      .join(" ")
    : `${title} - ${number} - ${brand}`;


  return <div className="col-sm-12 col-6 product-default left-details product-list mb-2" style={{ minWidth: "250px", borderBottom: '1px solid #CCC' }}>

    <figure style={{ marginBottom: 'auto', position: 'relative', minWidth: "200px", }}>
      {
        art_type === 'OENumber' && <div style={{
          position: 'absolute',
          width: '100px',
          height: '70px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          top: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundPosition: 'center',
          backgroundImage: `url('${gdcURL}/make_logo/${mfa_id}.png')`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat'
        }}></div>
      }
      {
        art_type !== 'OENumber' && <div style={{
          position: 'absolute',
          width: '190px',
          height: '40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          top: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundPosition: 'center',
          backgroundImage: `url('${Config.statement_api}/public/suppliers_logo/${suplogo}')`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat'
        }} ></div>
      }
      <a href={partURL} style={{ marginTop: '50px' }}>
        <img
          src={partImg ? partImg : default_image}
          width={300}
          height={300}
          style={{ width: '300px', marginTop: '40px', border: '0px solid #CCC', marginBottom: "20px" }}
          alt={title}
          onError={(e) => {
            const img = e.currentTarget;
            img.onerror = null;
            img.src = default_image;
            img.style.height = "180px";
            img.style.maxWidth = "200px";
            img.style.marginTop = "60px";
            img.style.marginBottom = "20px";
          }}
        />

      </a>
    </figure>

    <div className="product-details responsive-width-part-desc" style={{ minHeight: '300px' }} >

      <h3 className="product-title">
        <NavLink
          onClick={() => window.scrollTo(0, 0)}
          to={partURL}
        >
          {productTitle}
        </NavLink>
      </h3>

      <style>
        {
          `
          .product-title {
  margin: 0;
  line-height: 1.4;
}

.product-title a {
  display: block;
  text-decoration: none;
  color: inherit;

  /* Text wrap */
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}
          `
        }
      </style>

      <div className="ratings-container" style={{ margin: 0 }}>

        <div className="d-flex align-items-center justify-content-center">
          <small className="mt-1">{t('article_number', { value: number })} {" "} | {" "}</small>
          <div className="star-rating mt-1" style={{ color: 'red', fontSize: '18px' }}>

            {part && part.REVIEWS && part.REVIEWS !== "0" && Math.round(part.REVIEWS.split('-')[0]) !== 0 ?
              '★'.repeat(Math.round(part.REVIEWS.split('-')[0])) + '☆'.repeat(5 - Math.round(part.REVIEWS.split('-')[0]))
              : '☆☆☆☆☆'
            }
            <span>{part && part.REVIEWS && part.REVIEWS !== "0" && Math.round(part.REVIEWS.split('-')[0]) !== 0 ? <NavLink onClick={() => { window.scrollTo(0, 0); }} className={`ml-2 product-description__item-value`} to={partURL} style={{ color: '#0068d7', fontWeight: 500, fontSize: '12px', WebkitFontSmoothing: 'antialiased' }}>{" "}{" "}  {t('reviews')} - {part.REVIEWS.split('-')[1]}</NavLink> : ''}</span>
          </div>

          {part && part.REVIEWS && part.REVIEWS !== "0" ? <span></span> : <span className="mt-1 ml-2"><NavLink onClick={() => { window.scrollTo(0, 0); }} to={partURL} style={{ color: '#0068d7' }}><b>{t('submit_a_review')}</b></NavLink></span>}
        </div>
        {/* End .product-ratings */}
      </div>
      {/* End .product-container */}
      <p className="product-description w-100 pr-5">
        {
          parsedCriteria && <table
            className="table table-striped w-100 mr-4"
            dir={dir}
            style={{
              textAlign: (dir === 'rtl' ? 'right' : 'left'),
              marginBottom: 0
            }}
          >

            <tbody>
              {
                parsedCriteria &&
                parsedCriteria?.slice(0, 5).map((crt, indixSub) => {
                  return dir === 'rtl' ? (
                    <tr key={`info-tr-${indixSub}`}>
                      <th
                        style={{
                          paddingTop: '3px',
                          borderTop: '1px solid #f1f2f4',
                          paddingBottom: '3px'
                        }}
                      >
                        <span className="product-description__item-title">
                          {crt.criteria_ar}
                        </span>
                      </th>

                      <td
                        style={{
                          paddingTop: '3px',
                          borderTop: '1px solid #f1f2f4',
                          paddingBottom: '3px'
                        }}
                      >
                        <span className="product-description__item-value">
                          {crt.value_ar}
                        </span>
                      </td>
                    </tr>
                  ) : (
                    <tr key={`info-tr-${indixSub}`}>
                      <th
                        style={{
                          paddingTop: '3px',
                          borderTop: '1px solid #f1f2f4',
                          paddingBottom: '3px'
                        }}
                      >
                        <span className="product-description__item-title">
                          {crt.criteria_en}
                        </span>
                      </th>

                      <td
                        style={{
                          paddingTop: '3px',
                          borderTop: '1px solid #f1f2f4',
                          paddingBottom: '3px'
                        }}
                      >
                        <span className="product-description__item-value">
                          {crt.value_en}
                        </span>
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>

          </table>
        }
      </p>

      {/* {part?.OEM_NUMBERS && (
        <div className="mt-0 mb-3" style={{ width: '100%' }}>

          <div
            className="d-flex align-items-center text-primary cursor-pointer"
            style={{ gap: '5px' }}
            onClick={(e) => {
              const target = e.currentTarget;
              const content = target.nextElementSibling;
              content.classList.toggle('d-none');
              const isVisible = !content.classList.contains('d-none');
              target.querySelector('i').className = `product-description__item-title fas ${isVisible ? 'fa-minus-circle' : 'fa-plus-circle'}`;
            }}
          >
            <i style={{ fontSize: '18px' }} className="product-description__item-title fas fa-plus-circle"></i>
            <span
              className="product-description__item-title"
              style={{ cursor: "pointer" }}
            >{t('show_oem_numbers')}</span>
          </div>


          <div
            className="d-none"
            style={{
              maxHeight: '80px',
              overflowY: 'auto',
              padding: '5px',
              marginTop: '5px',
              width: '100%'
            }}
          >
            <table style={{ width: '100%' }}>
              {part && part.OEM_NUMBERS && part.OEM_NUMBERS.map((oem, index) => (

                <tr key={`info-tr-${index}`} >
                  <td style={{ paddingTop: '3px', borderTop: '1px solid #f1f2f4', paddingBottom: '3px' }}><span className="product-description__item-value">
                    {oem.ARL_BRA_BRAND} {oem.ARL_DISPLAY_NR}
                  </span></td>
                </tr>

              ))}
            </table>
          </div>
        </div>
      )} */}




      {/* {part?.OEM_NUMBERS && (
        <div className="mt-0 mb-3" style={{ width: "100%" }}>
          <div
            className="d-flex align-items-center text-primary cursor-pointer"
            style={{ gap: "5px" }}
            onClick={(e) => {
              const target = e.currentTarget;
              const content = target.nextElementSibling;

              content.classList.toggle("d-none");

              const isVisible = !content.classList.contains("d-none");

              target.querySelector("i").className = `product-description__item-title fas ${isVisible ? "fa-minus-circle" : "fa-plus-circle"
                }`;
            }}
          >
            <i
              style={{ fontSize: "18px" }}
              className="product-description__item-title fas fa-plus-circle"
            ></i>

            <span
              className="product-description__item-title"
              style={{ cursor: "pointer" }}
            >
              {t("show_oem_numbers")}
            </span>
          </div>

          <div
            className="d-none"
            style={{
              maxHeight: "80px",
              overflowY: "auto",
              padding: "5px",
              marginTop: "5px",
              width: "100%",
            }}
          >
            <table style={{ width: "100%" }}>
              <tbody>
                {part.OEM_NUMBERS.split("\n").map((oem, index) => (
                  <tr key={index}>
                    <td
                      style={{
                        paddingTop: "3px",
                        borderTop: "1px solid #f1f2f4",
                        paddingBottom: "3px",
                      }}
                    >
                      <span className="product-description__item-value">
                        {oem}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )} */}


      {part?.OE_CROSS_NUMBERS && (
        <div className="mt-0 mb-3" style={{ width: "100%" }}>
          <div
            className="d-flex align-items-center text-primary cursor-pointer"
            style={{ gap: "5px" }}
            onClick={(e) => {
              const target = e.currentTarget;
              const content = target.nextElementSibling;

              content.classList.toggle("d-none");

              const isVisible = !content.classList.contains("d-none");

              target.querySelector("i").className = `product-description__item-title fas ${isVisible ? "fa-minus-circle" : "fa-plus-circle"
                }`;
            }}
          >
            <i
              style={{ fontSize: "18px" }}
              className="product-description__item-title fas fa-plus-circle"
            ></i>

            <span
              className="product-description__item-title"
              style={{ cursor: "pointer" }}
            >
              {t("show_oem_numbers")}
            </span>
          </div>

          <div
            className="d-none"
            style={{
              maxHeight: "80px",
              overflowY: "auto",
              padding: "5px",
              marginTop: "5px",
              width: "100%",
            }}
          >
            <table style={{ width: "100%" }}>
              <tbody>
                {(() => {
                  try {
                    const oemData = JSON.parse(part.OE_CROSS_NUMBERS);
                    return oemData.map((item, index) => (
                      <tr key={index}>
                        <td
                          style={{
                            paddingTop: "3px",
                            borderTop: "1px solid #f1f2f4",
                            paddingBottom: "3px",
                          }}
                        >
                          <span className="product-description__item-value">
                            {item.ARL_BRA_BRAND} - {item.ARL_DISPLAY_NR}
                          </span>
                        </td>
                      </tr>
                    ));
                  } catch (error) {
                    console.error("Failed to parse OE_NUMBERS_CROSS:", error);
                    return null;
                  }
                })()}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {part && part.PT_NOTE && <div className="container"><div style={{ border: '1px solid #f85a00', borderRadius: '6px', padding: '16px', color: '#132530', fontSize: '12px' }}><svg style={{ marginRight: '2px' }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#f85a00" className="bi bi-info-circle" viewBox="0 0 16 16">
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
      </svg> IMPORTANT <div className="mt-1">{part.PT_NOTE}</div></div><br /><br /></div>}
      <div className="col-lg-12 mb-3">
        <NavLink onClick={() => { window.scrollTo(0, 0); }} to={partURL} className="btn btn-outline-dark" style={{ textTransform: 'capitalize', paddingTop: '12px', paddingBottom: '12px', paddingLeft: '35px', paddingRight: '35px' }}>{t('details')} <i className="fas fa-long-arrow-alt-right"></i></NavLink>
      </div>

      {/* End .price-box */}

    </div>

    <div className="product-action" style={{ marginBottom: 'auto' }}>
      <div className="price-box" style={{ width: '300px' }}>
        <table>
          <tr>
            <td colSpan={2} style={{ textAlign: "left" }}>

              {qty > 0 ? <span>
                <i
                  style={{ color: 'rgb(11, 207, 28)', marginRight: "5px" }}
                  className="far fa-dot-circle"></i>
                {t('in_stock')} (Item(s) left: {qty})</span>
                :
                <span
                  style={{ color: 'rgba(205, 35, 9, 1)' }}>
                  <i className="far fa-dot-circle"></i> {""} {t('out_of_stock')}
                </span>
              }

              <div style={{ textAlign: "left", marginBottom: "10px", marginTop: "10px", }}>
                {
                  beforePrice > 0 && beforePrice > numericPriceDisplay && (
                    <>
                      <small className="text-muted d-flex">
                        <span style={{ marginRight: "3px" }}>Was: </span>
                        <del>
                          {beforePrice.toFixed(2)}AED
                        </del>
                      </small>
                    </>
                  )
                }


              </div>

              {qty > 0 && price > 0 &&
                <div style={{ textAlign: "left", }}>
                  <span
                    style={{
                      fontSize: '32px',
                      fontWeight: 700,
                      color: '#000'
                    }}
                  >{display_price}</span>
                </div>
              }


              {qty > 0 && price > 0 && <span style={{ textAlign: "left" }} className="">
                <small>
                  <span className='text-success' style={{ fontWeight: "bold" }}>
                    Offer price excl. 5.0% VAT, </span>
                  {(currency || "").toLowerCase() !== "usd" && <span style={{ fontWeight: "bold" }} className='text-danger'>Free delivery</span>}
                </small>
              </span>
              }

            </td>
          </tr>

          {
            qty > 0 && price > 0 && (currency || "").toLowerCase() !== "usd" &&

            <tr>
              <td colSpan={7}>
                {((stock_delivery_days || 0) + (business_delivery_days || 0)) > 0 && (
                  <>
                    <DeliveryDaysComponent
                      stock_delivery_days={stock_delivery_days}
                      business_delivery_days={business_delivery_days}
                    />
                  </>
                )}
              </td>
            </tr>
          }


          {qty > 0 && price > 0 &&
            <tr>
              <td>

                <table className='table-bordered' style={{ width: '110px' }}>
                  <tr>
                    <td
                      width={50}
                      rowSpan={2}
                      style={{
                        verticalAlign: 'middle',
                        textAlign: 'center',
                        fontWeight: '500',
                        color: '#132530',
                        height: '50px'
                      }}
                    >
                      {selectQty}
                    </td>

                    <td
                      width={30}
                      style={{
                        padding: 0,
                        textAlign: 'center',
                        fontSize: '12px',
                        cursor: "pointer"
                      }}
                      onClick={() => incrementQty()}
                    >
                      <i className='fas fa-chevron-up'></i>
                    </td>
                  </tr>
                  <tr>
                    <td
                      width={30}
                      style={{
                        padding: 0,
                        textAlign: 'center',
                        fontSize: '12px',
                        cursor: "pointer"
                      }}
                      onClick={() => decrementQty()}
                    >
                      <i className='fas fa-chevron-down'></i>
                    </td>
                  </tr>
                </table>

              </td>

              <td>
                {qty > 0 && price > 0 &&
                  <>
                    <button
                      onClick={handleAddToCart}
                      className="btn btn-dark add-cart mr-2 text-light"
                      title={t('add_to_cart')}
                      disabled={loadings || addToCartLoading ||
                        isAddingRef.current
                      }
                    >
                      <i className="fas fa-cart-plus mr-2"></i>{t('buy')}
                    </button>
                    {/* <button
                    onClick={isFavorite ? handleRemoveFromFavorite : handleAddToFavorite}
                    className={`btn mt-1 add-cart  ${isFavorite ? 'btn-danger' : 'btn-outline-danger'}`} 
                    
                    title={t('add_to_favorite')}
                    style={{ marginLeft: '8px' }}
                  >
                    <i className="fas fa-heart"></i>
                  </button> */}
                  </>
                }
              </td>
            </tr>
          }

          {qty > 0 && price > 0 &&
            <tr>
              <td colSpan={3}>
                <div className=" mt-2 text-left" style={{ cursor: 'pointer' }} onClick={() => isFavorite ? handleRemoveToFavorite() : handleAddToFavorite()}>
                  <i className={`isFavorite ${isFavorite ? 'fas' : 'far'} fa-heart favHeart ${isFavorite ? 'active' : ''}`} style={{ fontSize: '18px' }} ></i> <span style={{ fontSize: '14px', fontWeight: '500', paddingBottom: '2px' }}>{t('add_to_wishlist')}</span>
                </div>
              </td>
            </tr>
          }

          {
            (part?.stock_oe === 0 || part?.stock_oe === null) && SUP_WARRANTY && <img
              src={`/assets/warrenty/${GetWarrantyImage(SUP_WARRANTY)}`}
              alt="warranty"
              title={SUP_WARRANTY}
              style={{
                width: '100px',
                marginTop: "10px"
              }}
            />
          }

        </table>
        {
          qty > 0 && price > 0 &&
          currency.toLowerCase() !== "usd" &&
          <div className="alert alert-danger" style={{ border: "1px dashed #f06548" }}>
            <div className="d-flex align-items-center">

              <lord-icon
                src="https://cdn.lordicon.com/nkmsrxys.json"
                trigger="loop"
                style={{ width: "60px", height: "60px" }}
                colors="primary:#cc000b,secondary:#0e1f2a"
              />

              <div>
                <span style={{ color: "#000" }}>
                  You will get
                </span>

                <span className="ml-2 mr-2">
                  <b className='text-primary'>
                    {UseRewardsPoints(price) ?? 0} rewards points
                  </b>
                </span>

                <span style={{ color: "#000" }}>
                  on this
                </span>
              </div>

            </div>
          </div>

        }

      </div>

    </div>

  </div >
}
const ImageWithFallback = ({ src, index, alt, fallbackText, OE }) => {
  const [imgError, setImgError] = useState(false);

  const handleError = () => {
    setImgError(true);
  };
  const fallbackStyle = {
    textAlign: "center",
    fontSize: "10px",
    padding: "10px",
    wordBreak: "break-word",
    maxWidth: "90%",
  };

  const containerStyle = {
    position: "absolute",
    width: "210px",
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    top: 0,
  };
  return (
    <div style={containerStyle}>
      {imgError ? (
        <div style={fallbackStyle}>{fallbackText}</div>
      ) : (
        <img
          draggable="false"
          style={{
            height: "50px",
            margin: "auto",
            float: "none",
            marginTop: OE === false ? "5px" : 0,
          }}
          key={`img-part-${index}`}
          src={src}
          alt={alt}
          onError={handleError}
        />
      )}
    </div>
  );

};

export default PartsHorizontalCard;